import { CellComponent } from 'tabulator-tables';

export default function newLineFormatter(cell: CellComponent): string {
	if (cell.getValue()) {
		return cell.getValue().split('\n').join('<br/>');
	}
	return '';
}
